<template>
  <!-- 蒙层 -->
  <div class="modal-mask" v-if="show" @click.self="close">
    <!-- 弹窗内容 -->
    <div class="modal-content">
      <div class="modal-header">
        <h3>余额充值</h3>
        <span class="close" @click="close">×</span>
      </div>

      <div class="modal-body">
        <!-- 余额 -->
        <div class="balance">当前余额：{{ balance }} 元</div>

        <!-- 金额选择 -->
        <div class="label">选择充值金额</div>
        <div class="amount-list">
          <div
            class="amount-item"
            :class="{ active: selectAmount === item }"
            v-for="item in amountList"
            :key="item"
            @click="select(item)"
          >
            {{ item }}元
          </div>
        </div>

        <!-- 自定义输入 -->
        <div class="label">自定义金额</div>
        <input
          v-model="selectAmount"
          class="input"
          placeholder="请输入充值金额"
          @input="handleInput"
        />

        <!-- 支付方式 -->
<!--        <div class="label">支付方式</div>-->
<!--        <div class="pay-type">-->
<!--          <div class="pay-item" :class="{ active: payType == 'wx' }" @click="payType='wx'">-->
<!--            微信支付-->
<!--          </div>-->
<!--          <div class="pay-item" :class="{ active: payType == 'ali' }" @click="payType='ali'">-->
<!--            支付宝-->
<!--          </div>-->
<!--        </div>-->
      </div>

      <div class="modal-footer">
        <button class="btn cancel" @click="close">取消</button>
        <button class="btn confirm" @click="submit">确认充值</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RechargeModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    balance: {
      type: String,
      default: "0.00"
    }
  },
  data() {
    return {
      amountList: [10, 20, 50, 100, 200, 500],
      selectAmount: 10,
      payType: "wx"
    }
  },
  methods: {
    handleInput() {
      // 过滤规则同上
      let val = this.selectAmount.replace(/[^\d.]/g, '');
      val = val.replace(/\.+/, '.');
      val = val.replace(/(\.\d{2})\d+/, '$1');
      val = val.replace(/^\./, '');
      this.selectAmount = val * 1;
    },
    // 选择金额
    select(price) {
      this.selectAmount = price
    },
    // 关闭弹窗
    close() {
      this.$emit("update:show", false)
    },
    // 提交充值
    submit() {
      if (!this.selectAmount || this.selectAmount < 1) {
        alert("请输入正确的充值金额")
        return
      }

      // 把结果传给父页面
      this.$emit("success", {
        amount: this.selectAmount,
      })
    }
  }
}
</script>

<style scoped>
/* 蒙层 */
.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}
/* 弹窗 */
.modal-content {
  width: 90%;
  max-width: 400px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}
/* 头部 */
.modal-header {
  padding: 15px;
  text-align: center;
  position: relative;
  border-bottom: 1px solid #eee;
}
.modal-header h3 {
  margin: 0;
  font-size: 18px;
}
.close {
  position: absolute;
  right: 15px;
  top: 15px;
  font-size: 20px;
  cursor: pointer;
}
/* 内容 */
.modal-body {
  padding: 20px;
}
.balance {
  text-align: center;
  margin-bottom: 20px;
  color: #666;
}
.label {
  font-size: 14px;
  margin-bottom: 8px;
  color: #333;
}
/* 金额列表 */
.amount-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}
.amount-item {
  flex: 1;
  min-width: 22%;
  height: 44px;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.amount-item.active {
  border-color: #0088ff;
  background: #e6f3ff;
  color: #0088ff;
}
/* 输入框 */
.input {
  width: 100%;
  height: 44px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 10px;
  margin-bottom: 15px;
  box-sizing: border-box;
  outline: none;
}
/* 支付方式 */
.pay-type {
  display: flex;
  gap: 12px;
}
.pay-item {
  flex: 1;
  height: 48px;
  border: 1px solid #ddd;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.pay-item.active {
  border-color: #0088ff;
  background: #e6f3ff;
  color: #0088ff;
}
/* 底部按钮 */
.modal-footer {
  display: flex;
  padding: 15px;
  border-top: 1px solid #eee;
}
.btn {
  flex: 1;
  height: 44px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 16px;
}
.cancel {
  background: #f5f5f5;
  margin-right: 10px;
}
.confirm {
  background: #0088ff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/RechargeModal.vue